var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('p',[_vm._v("中科名兽医")]),_c('router-link',{staticClass:"router-style",attrs:{"to":"pigPrice"}},[_vm._v("中科名兽医生物安全测评")]),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }